module.exports = __webpack_public_path__ + "static/img/kk.2a287d44.png";